import Icon from 'atoms/Icon';
import Text from 'atoms/Text';
import useClickOutside from 'components/useClickOutSide';
import { useEffect, useRef, useState } from 'react';
import ActionDropBoxV2 from './ActionDropBoxV2';
import CustomMultiSelect from './CustomMultiSelect';
import CustomAsyncSelectPaginateV2 from './CustomAsyncSelectPaginateV2';

function AsyncSelectPaginateV2({
    control,
    register,
    name,
    placeholder,
    options,
    watch,
    onRemove,
    label,
    loadOptions = () => { },
    isMulti = true,
    setValue,
    isRequired = false,
    isDisabled = false,
    onChange = () => { },
    isError,
    errorMessage,
    showDots = true,    
    onSelectAllChange = () => { },
    customClass = '',
    ...rest
}) {
    const [showFilter, setShowFilter] = useState(false);
    const [dropdownDirection, setDropdownDirection] = useState('bottom');

    const containerRef = useRef();
    const triggerRef = useRef();

    useClickOutside(containerRef, () => setShowFilter(false));

    useEffect(() => {
        if (!showFilter || !triggerRef.current) return;

        const rect = triggerRef.current.getBoundingClientRect();
        const dropdownHeight = 320;
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;

        if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
            setDropdownDirection('top');
        } else {
            setDropdownDirection('bottom');
        }
    }, [showFilter]);

    const actionButtons = [
        // {
        //     label: 'Remove',
        //     kind: 'silent',
        //     onClick: onRemove
        // },
        // {
        //     label: 'Close',
        //     kind: 'secondaryLoud',
        //     onClick: () => setShowFilter(false),
        //     className: '!flex md:!hidden'
        // },
        // {
        //     label: 'Ok',
        //     onClick: () => setShowFilter(false)
        // }
    ];


    return (
        <div className='relative' ref={containerRef}>
            <label className="text-[12px] text-gray-1100 mb-1 block leading-4">
                {label} {isRequired && <span className="text-red-700 ml-1">*</span>}
            </label>

            <div className={`flex justify-between items-center border cursor-pointer relative ${isDisabled && 'opacity-40 cursor-not-allowed'} ${isError ? 'border-[#da291c]': 'border-gray-200'}`} ref={triggerRef} >
                <div
                    ref={triggerRef}
                    className={`flex justify-between items-center w-full bg-white px-3 h-8 text-xs gap-3 ${customClass}`}
                    onClick={() => !isDisabled && setShowFilter(!showFilter)}
                >
                    <Text className='truncate pr-2' variant='body'>
                        {!watch(name)?.length ? `${placeholder} ${showDots ? ':' : ''}` : ''} {isMulti ? watch(name)?.map(item => item.label + ', ') : watch(name)?.value}
                    </Text>
                    <Icon icon='chevron_down__l__stroke' size='w-4 h-4' />
                </div>
                {(isMulti ? (watch(name)?.length > 0) : !!watch(name)) && (
                    <Icon icon='close__l__stroke' size='w-3 h-3 !absolute right-7 -top-1.5  ' onClick={onRemove} />
                )}
            </div>
            {isError && <div className="text-red-900 text-[12px] pt-1 error-in-field">{errorMessage}</div>}
            {
                showFilter && (
                    <ActionDropBoxV2
                        label={label}
                        onClose={() => setShowFilter(false)}
                        buttons={actionButtons}
                        triggerRef={triggerRef}
                        {...rest}
                    >
                        <CustomAsyncSelectPaginateV2
                            cacheOptions
                            loadOptions={(input, { }, page) => loadOptions(input, watch(), page)}
                            control={control}
                            register={register}
                            name={name}
                            components={isMulti ? { Option: CustomMultiSelect } : {}}
                            isMulti={isMulti}
                            show
                            value={watch(name)}
                            watch={watch}
                            closeMenuOnSelect={false}
                            menuPosition="fixed"
                            menuPlacement="auto"
                            options={options}
                            placeholder={'Search or select one more options'}
                            size='sm'
                            className='filter-select dark'
                            defaultMenuIsOpen
                            menuIsOpen
                            hideSelectedOptions={false}
                            defaultOptions={options ?? []}
                            autoFocus
                            setValue={setValue}
                            onChange={onChange}
                            isError={isError}
                            errorMessage={errorMessage}
                            onSelectAllChange={onSelectAllChange}
                        />
                    </ActionDropBoxV2>
                )
            }
        </div>
    )
}

export default AsyncSelectPaginateV2